import { render, staticRenderFns } from "./AppProfile.vue?vue&type=template&id=4ebd72bb&scoped=true&"
import script from "./AppProfile.vue?vue&type=script&lang=js&"
export * from "./AppProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebd72bb",
  null
  
)

export default component.exports